export default __webpack_public_path__ + "static/media/o-card.360bc12f.png";